var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountTopLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 80,
    cy: 80,
    r: 80
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.2%",
    y: "-1.2%",
    width: "102.5%",
    height: "102.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-7.2%",
    y: "-7.2%",
    width: "114.4%",
    height: "114.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.514369788   0 0 0 0 0.482195797   0 0 0 0 0.586761267  0 0 0 1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u270F\\uFE0F-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MyPlan---Copy-2",
    transform: "translate(-760.000000, -197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(760.000000, 197.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval-3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#1B152A",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Forever-logo",
    filter: "url(#filter-3)",
    transform: "translate(21.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    points: "65 108.071983 71.6977086 107 72 108.787083 67.4217587 109.520194 67.8193302 111.871619 71.2103408 111.328623 71.5126322 113.116374 68.1216216 113.659369 68.7968077 117.660461 66.6780259 118"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.6525141,109.845436 C80.01462,108.056001 79.0671494,106.699001 77.4685965,107.269566 C75.8700435,107.840131 75.9977612,109.489354 76.6370435,111.279484 C77.2756318,113.069613 78.2217141,114.425919 79.8202671,113.85466 C81.41882,113.284095 81.2924906,111.634872 80.6525141,109.845436 M74.4505729,112.059672 C73.4024553,109.12286 73.8730671,106.474801 76.8105729,105.425989 C79.7473847,104.377178 81.7894788,106.127742 82.8382906,109.064554 C83.8871024,112.001366 83.4164906,114.650119 80.4789847,115.698931 C77.5414788,116.747742 75.4986906,114.997178 74.4505729,112.059672",
    id: "Fill-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9882271,105.389895 C88.81978,104.888048 88.9752624,104.134236 88.5705918,103.464413 C88.1673094,102.793895 87.42738,102.578719 86.5958271,103.080566 L85.0687682,104.00166 L86.4618624,106.310989 L87.9882271,105.389895 Z M82.2339918,103.510919 L85.6226741,101.467436 C87.5710624,100.291601 89.4347682,100.404048 90.5571565,102.266366 C91.5379447,103.892684 91.0416506,105.596742 89.6395329,106.442872 L89.6270388,106.449813 L94.6406506,108.251048 L92.2563565,109.688566 L87.3968388,107.863036 L89.5007094,111.350978 L87.6390859,112.473366 L82.2339918,103.510919 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FFFFFF",
    points: "90.0054718 98.5944835 95.15166 94.0334365 96.40246 95.4452718 92.8839776 98.5625541 94.3853541 100.256895 96.9910718 97.9468718 98.2418718 99.3587071 95.6361541 101.668036 97.3311894 103.578942 100.956566 100.365178 102.20806 101.776319 96.9528953 106.433154"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFFFFF",
    points: "95.6492729 93.6956788 97.0604141 91.8729259 104.772755 94.4911376 100.223508 87.7929024 101.634649 85.9701494 107.663755 95.2824318 106.170708 97.2086082"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FFFFFF",
    points: "101.838026 85.3893118 104.976132 79.2741353 106.65312 80.1355353 104.508296 84.3148176 106.520544 85.3476647 108.110073 82.2512059 109.787061 83.1126059 108.197532 86.2090647 110.467991 87.3737941 112.679449 83.0647118 114.357132 83.9261118 111.152391 90.1703941"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.117129,75.2778224 C111.392,74.3456224 110.997741,73.6855165 110.246012,73.4633988 C109.495671,73.2412812 108.805718,73.5827871 108.529459,74.5142929 L108.025529,76.2245988 L110.611812,76.9888224 L111.117129,75.2778224 Z M105.600976,77.77734 L106.721976,73.9805165 C107.367506,71.7968224 108.816824,70.6223753 110.902647,71.2380576 C112.724706,71.7759988 113.509753,73.3683047 113.046082,74.9404812 L113.041918,74.9536694 L117.958353,72.8969988 L117.170529,75.5679635 L112.350576,77.5017753 L116.258459,78.6553988 L115.642776,80.7412224 L105.600976,77.77734 Z",
    id: "Fill-12",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7868059,117.420412 C24.4777118,116.128659 -0.666005882,88.8894 0.627135294,56.5803059 C1.91958235,24.2719059 29.1581471,-0.871811765 61.4672412,0.420635294 C93.7756412,1.71377647 118.919359,28.9523412 117.626218,61.2614353",
    id: "Stroke-14",
    stroke: "#FFFFFF",
    strokeWidth: 3.87759601,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9808412,24.5472624 C62.7541353,22.0116506 56.3502059,23.0639329 52.2243706,27.09398 C49.1140294,30.1307447 47.8597588,33.8755094 47.9409706,38.2005565 C47.5161706,38.3192506 47.1462059,38.4407212 46.7686059,38.5233212 C38.6585353,40.2530624 32.8744529,48.1701682 33.8080412,56.2719094 C34.8200647,65.0740153 42.3130647,71.6028859 50.9784294,71.2738741 C52.1306647,71.2294506 52.7997941,70.75398 52.8261706,69.6107682 C52.8525471,68.4418741 52.0959588,67.9323918 51.0173,67.8588153 C50.1739471,67.8018976 49.3153235,67.8754741 48.4809941,67.7630271 C42.5337941,66.9529918 37.4799235,61.6568741 37.1925588,55.9706624 C36.8371706,48.9878388 40.6929941,43.4807094 47.1177471,41.9272741 C48.6003824,41.5684153 50.1531235,41.4934506 51.9141,41.2574506 C51.7967941,40.6702271 51.7190529,40.1933682 51.6079941,39.7248388 C49.6283706,31.2899212 57.5413118,24.5035329 65.2120059,27.0363682 C69.4128059,28.4225212 72.9465588,32.6656624 72.4051471,38.1609918 C72.2711824,39.4971682 72.9750176,40.4258976 74.0175824,40.3842506 C75.1663471,40.3363565 75.6293235,39.5679682 75.7466294,38.5080506 C76.3748059,32.7489565 73.2325353,27.0932859 67.9808412,24.5472624",
    id: "Fill-16",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5813835,67.5008588 C68.67836,67.5751294 65.1404424,68.617 62.0196894,71.6239176 C62.0196894,64.3801059 62.0210776,57.4653059 62.0176071,50.5525882 C62.0176071,48.9984588 61.3498659,48.0433529 60.2462188,48.1384471 C58.8649247,48.2571412 58.5275835,49.1796235 58.5296659,50.4498588 C58.5525718,64.0920471 58.54216,77.7314588 58.5463247,91.3729529 C58.5463247,92.8500353 59.1994894,93.7176824 60.2996659,93.6246706 C61.6885953,93.5101412 62.0398188,92.5737765 62.0314894,91.3160353 C62.0009482,87.7815882 61.9988659,84.2457529 62.0252424,80.7113059 C62.0578659,76.7305412 63.8389718,73.7999765 67.5663835,72.3291412 C69.2010306,71.6829176 71.0043482,71.4372 72.7535247,71.1276235 C73.9335247,70.9193882 74.9705365,70.6438235 74.9011247,69.1931176 C74.8282424,67.7528235 73.8058071,67.4786471 72.5813835,67.5008588",
    id: "Fill-18",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountTopLogo);
export default __webpack_public_path__ + "static/media/account-top-logo.a0c8d6275666573119efbb07343e210a.svg";
export { ForwardRef as ReactComponent };